import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import appStateSlice from './appState-slice';

const store = configureStore({
  // Reducers
  reducer: {
    appStateReducer: appStateSlice.reducer,
  },

  // non-serializable values are Promises, Symbols, Maps/Sets, functions, or class instances.
  // As sometimes we need to pass new Error which is instance of class Error so we have to use
  // the middleware to suppress the warning
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Actions
export const appStateActions = appStateSlice.actions;

export default store;
